function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
/**
 * ChangeAtBlurWrapper
 * onChange invoked only at Blur
 * This improves performance by eliminating onChange being invoked for each keystroke.
 * Fields wrapped with this wrapper have an optional boolean prop changeAtBlur.
 * When changeAtBlur is true it causes the onChange to be only invoked once,
 * just before the onBlur, and only if the value actually changed.
 *
 * NOTE: onChange receives the new value and not an Event object.
 */

export var ChangeAtBlurWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ChangeAtBlurWrapper, _React$Component);

  var _super = _createSuper(ChangeAtBlurWrapper);

  function ChangeAtBlurWrapper(props) {
    var _this;

    _classCallCheck(this, ChangeAtBlurWrapper);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, props].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isControlled", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      dirty: false,
      focused: false,
      valueExternal: undefined,
      valueInternal: null,
      valueOnFocus: null
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (eventOrValue) {
      var newValue = eventOrValue && eventOrValue.target ? eventOrValue.target.value : eventOrValue;

      if (!_this.state.focused) {
        // eslint-disable-next-line no-console
        console.error('[ChangeAtBlur] onChange invoked when component is not focused! value:', newValue);
      }

      var valueOnFocus = _this.state.valueOnFocus;
      var dirty = newValue !== valueOnFocus;

      _this.setState({
        dirty: dirty,
        valueInternal: newValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      event.persist();

      _this.setState(function (prevState) {
        var dirty = prevState.dirty,
            valueInternal = prevState.valueInternal;

        if (dirty && _this.props.onChange) {
          _this.props.onChange(valueInternal);
        }

        return {
          dirty: false,
          focused: false,
          valueOnFocus: valueInternal
        };
      }, function () {
        if (_this.props.onBlur) {
          _this.props.onBlur(event);
        }
      });
    });

    _this.isControlled = props.value !== undefined;

    if (!_this.isControlled) {
      // not controlled, use internal state
      var defaultValue = props.defaultValue;

      if (defaultValue !== undefined) {
        _this.state.valueInternal = defaultValue;
        _this.state.valueOnFocus = defaultValue;
      }
    }

    return _this;
  }

  _createClass(ChangeAtBlurWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          value = _this$props.value,
          WrappedComponent = _this$props.WrappedComponent,
          other = _objectWithoutProperties(_this$props, ["onBlur", "onChange", "onFocus", "value", "WrappedComponent"]);

      var valueInternal = this.state.valueInternal;
      return (
        /*#__PURE__*/
        React.createElement(WrappedComponent, _extends({}, other, {
          onBlur: this.onBlur,
          onChange: this.onChange,
          onFocus: this.onFocus,
          value: valueInternal
        }))
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var valueExternal = nextProps.value;

      if (prevState.valueExternal !== valueExternal) {
        var valueInternal = prevState.valueInternal,
            valueOnFocus = prevState.valueOnFocus;
        var dirty = prevState.dirty,
            focused = prevState.focused;

        if (!focused || !dirty) {
          valueInternal = valueExternal;
          valueOnFocus = valueExternal;
        }

        return {
          valueExternal: valueExternal,
          valueInternal: valueInternal,
          valueOnFocus: valueOnFocus
        };
      }

      return null;
    }
  }]);

  return ChangeAtBlurWrapper;
}(React.Component);